(function () {
  'use strict';

  var module = angular.module('wsLrs.controllers');

  // Set up all "vanilla" resources
  var resourceTemplates = [{
    name: "Example",
    path: "/example",
    skipTenantPrefix: true
  }, {
    name: "CardTemplates",
    path: "/card-templates",
    skipTenantPrefix: true
  }];
  _.each(resourceTemplates, function (template) {
    module.factory(template.name, ['Api', 'Resource', function (Api, Resource) {
      return new Resource(template.path, template.skipTenantPrefix, template.sharePath);
    }]);
  });
  module.factory("Groups", ['$http', '$q', 'Resource', 'User', 'ShareUtils', function ($http, $q, Resource, User, ShareUtils) {
    var self = new Resource("/groups", false, true),
      baseCount = self.count.bind(self);
    _.extend(self, {
      countByLetter: function countByLetter(cfg) {
        return $http.get(self.__apiUrl() + "count-by-letter", cfg).then(function (response) {
          return response.data;
        });
      },
      __countPromises: {},
      count: function count() {
        var cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var user = User.get(),
          orgId = user && user.organization && user.organization.id;
        if (!orgId && !ShareUtils.hasShareKey()) {
          return $q.resolve(0);
        }
        var params = _.extend({}, cfg.params);
        if (params && params.demo === false) {
          delete params.demo;
        }
        var url = self.getUrl(params);
        if (!self.__countPromises[url]) {
          self.__countPromises[url] = baseCount(cfg);
        }
        return self.__countPromises[url];
      }
    });
    return self;
  }]);
  module.factory("GroupTypes", ['$http', '$q', 'Resource', 'Demo', function ($http, $q, Resource, Demo) {
    var self = new Resource("/group-types", false, true);
    self._list = self.list;
    function shouldUpdateCache(groupTypeCache, key) {
      return !(groupTypeCache[key] && 'ALL' === key.split('|')[0]);
    }
    function shouldReturnPagedResults(params) {
      return !(typeof params === 'undefined' || params['card-group'] || params.report);
    }
    _.extend(self, {
      _groupTypeCache: {},
      buildCache: function buildCache() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        params = _.defaults(params, {
          "demo": Demo.isDemoMode(),
          "expandedPermissionsIfAllowed": true,
          "order_by": "displayOrder,name",
          "_limit": 100
        });
        var key = 'ALL';
        if (params.report) {
          key = 'REPORT|' + params.report;
        } else if (params['card-group']) {
          key = 'CARD_GROUP|' + params['card-group'];
        }
        if (shouldUpdateCache(this._groupTypeCache, key)) {
          this._groupTypeCache[key] = this._list(params);
        }
        return this._groupTypeCache[key];
      },
      countByLetter: function countByLetter(cfg) {
        return $http.get(self.__apiUrl() + "count-by-letter", cfg).then(function (response) {
          return response.data;
        });
      },
      setCache: function setCache(types) {
        if (types instanceof Array) {
          this._groupTypeCache = Promise.resolve(types);
        } else {
          throw new Error('Must pass an array to cacheTypes()');
        }
      },
      getCache: function getCache() {
        return this._groupTypeCache;
      },
      list: function list() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          params = _ref.params;
        return self.buildCache(params).then(function (res) {
          if (shouldReturnPagedResults(params)) {
            var offset = typeof params._offset === 'undefined' ? 0 : params._offset;
            var limit = typeof params._limit === 'undefined' ? res.count : params._limit;
            return {
              count: res.count,
              results: res.results.slice(offset, offset + limit)
            };
          }
          return res;
        });
      }
    });
    return self;
  }]);
  module.factory("People", ['$http', '$q', 'Resource', function ($http, $q, Resource) {
    var self = new Resource("/people", false);
    _.extend(self, {
      getPeopleWithMemberships: function getPeopleWithMemberships(cfg) {
        return $http.get(this.__apiUrl() + "reports/people-with-memberships", cfg).then(function success(response) {
          return response.data;
        }, function error(response) {
          return response.status === 404 ? null : $q.reject(response);
        });
      },
      countByLetter: function countByLetter(cfg) {
        return $http.get(self.__apiUrl() + "count-by-letter", cfg).then(function (response) {
          return response.data;
        });
      }
    });
    return self;
  }]);
  module.factory("Person", ['$http', '$q', 'Resource', function ($http, $q, Resource) {
    var self = new Resource("/people", false);
    _.extend(self, {
      getPersonImage: function getPersonImage(id, cfg) {
        return $http.get(this.__apiUrl() + id + "/img", cfg).then(function success(response) {
          return response.data;
        }, function error(response) {
          return response.status === 404 ? null : $q.reject(response);
        });
      }
    });
    return self;
  }]);
  module.factory("Activities", ['$http', '$q', 'Resource', function ($http, $q, Resource) {
    var self = new Resource("/acc/activities", false);
    _.extend(self, {
      multiGetByActivityId: function multiGetByActivityId(activityIds, cfg) {
        cfg = cfg || {};
        cfg.params = {
          activityIds: activityIds
        };
        return $http.get(this.__apiUrl() + "multi/by-activity-id", cfg).then(function success(response) {
          return response.data;
        }, function error(response) {
          return response.status === 404 ? null : $q.reject(response);
        });
      },
      multiGetByContextId: function multiGetByContextId(contextIds) {
        var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
          includeContextActivity: false
        };
        cfg.params = {
          contextIds: contextIds,
          includeContextActivity: !!cfg.includeContextActivity
        };
        return $http.get(this.__apiUrl() + "multi/by-context-id", cfg).then(function success(response) {
          return response.data;
        }, function error(response) {
          return response.status === 404 ? null : $q.reject(response);
        });
      },
      countByLetter: function countByLetter(cfg) {
        return $http.get(this.__apiUrl() + "count-by-letter", cfg).then(function (response) {
          return response.data;
        });
      }
    });
    return self;
  }]);
  module.factory("ActivityTypes", ['Resource', function (Resource) {
    return new Resource("/acc/activity-types");
  }]);
  module.factory("Verbs", ['$http', '$q', 'Resource', function ($http, $q, Resource) {
    var self = new Resource("/acc/verbs", false);
    _.extend(self, {
      countByLetter: function countByLetter(cfg) {
        return $http.get(this.__apiUrl() + "count-by-letter", cfg).then(function (response) {
          return response.data;
        });
      },
      multiGetByVerbId: function multiGetByVerbId(verbIds, cfg) {
        cfg = cfg || {};
        cfg.params = {
          verbIds: verbIds
        };
        return $http.get(this.__apiUrl() + "multi/by-verb-id", cfg).then(function success(response) {
          return response.data;
        }, function error(response) {
          return response.status === 404 ? null : $q.reject(response);
        });
      }
    });
    return self;
  }]);
  module.factory("ApiErrors", ['$http', '$q', 'Resource', function ($http, $q, Resource) {
    var self = new Resource("/errors", false);
    _.extend(self, {
      archiveAll: function archiveAll() {
        return $http.put(this.__apiUrl() + "archive-all", null).then(function success(response) {
          return response.data.updated;
        });
      },
      saveArchiveState: function saveArchiveState(id, newState) {
        var cfg = {
          params: {
            state: newState
          }
        };
        return $http.put(this.__apiUrl() + id + "/archive", null, cfg).then(function success(response) {
          return response.data;
        });
      }
    });
    return self;
  }]);
})();
